const COOKIES = {
  SSO_TOKEN: 'x-sso-token',
  USER_AGENT: 'x-user-agent',
  PASSCODE_VERIFIED: 'x-2fa-token',
  SHOW_RISK_DISCLOSURE: 'showRiskDisclosure'
};
const LOCAL_STORAGE = {
  TIME_RESOLUTION: 'tradingview.chart.lastUsedTimeBasedResolution',
  ACC_MANAGER_DIMENSION: 'tradingview.trading.panelWidth',
  BOTTOM_WIDGET: 'tradingview.chart.bottom-widgetbar',
  SAVED_WATCHLIST: 'tradingview.savedwatch',
  EDIS_BULK_AUTH_KEY: 'edisBulkAuthPayload',
  REQ_ID: 'reqId',
  WIDGET_SETTINGS: 'tradingview.widgetbar.layout-settings',
  RISK_DISCLOSURE_ACCEPTANCE: 'risk-disclosure-acceptance',
  RISK_DISCLOSURE_TRIGGER: 'risk_disclosure_trigger',
};

module.exports = {
  COOKIES,
  LOCAL_STORAGE
};